import { ReactComponent as WarningIcon } from '../../assets/icons/warning-triangle.svg';
import { SBanner, SDescription } from './Banner.style';

type BannerProps = {
  description: string;
};

export function Banner({ description }: BannerProps) {
  return (
    <SBanner>
      <WarningIcon />
      <SDescription>{description}</SDescription>
    </SBanner>
  );
}
